import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../form/Select';

export const GenderPronounSelectInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
}, ref) => (
  <Select
    id='in-page-lead-form-gender-pronoun-select'
    label='Pronoun'
    ref={ref}
    name='genderPronoun'
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    required={false}
    customTheme={'leads'}
    inputType='select'>
    <option value='' disabled>Select one</option>
    <option value='HeHimHis'>He&#47;Him&#47;His</option>
    <option value='SheHerHers'>She&#47;Her&#47;Hers</option>
    <option value='TheyThemTheirs'>They&#47;Them&#47;Theirs</option>
  </Select>
));

GenderPronounSelectInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default GenderPronounSelectInputComponent;
